import { render, staticRenderFns } from "./PublicAvailableTechs.vue?vue&type=template&id=84f7f2c4&scoped=true&"
import script from "./PublicAvailableTechs.vue?vue&type=script&lang=js&"
export * from "./PublicAvailableTechs.vue?vue&type=script&lang=js&"
import style0 from "./PublicAvailableTechs.vue?vue&type=style&index=0&id=84f7f2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f7f2c4",
  null
  
)

export default component.exports